export { default } from './Boleto25BlackBG';
